import React, { Component } from "react"
import Layout from "../Layout/Layout/Layout"
import SEO from "../SEO/SEO"
import WishlistView from "../Wishlist/WishlistView"
import Header from "../Shop/Header/Header"
import Utils from "../../utils/node.utils"

export default class WishlistPage extends Component {
  state = {}

  updateWishlistView = () => {
    this.setState({})
  }

  render() {
    const {
      title,
      description,
      location,
      originPage,
      language,
      contentMap,
      commonContentMap,
      breadCrumbs,
    } = this.props

    return (
      <Layout
        origin={location.origin}
        originPage={originPage}
        language={language}
        commonContentMap={commonContentMap}
      >
        <SEO
          title={title}
          language={language}
          keywords={[`lotta mae`, originPage]}
          description={description}
          selfLink={originPage}
        />
        <Header breadCrumbs={breadCrumbs} commonContentMap={commonContentMap} />
        <WishlistView
          updateWishlistView={this.updateWishlistView}
          language={language}
          commonContentMap={commonContentMap}
          contentMap={contentMap}
        />
      </Layout>
    )
  }
}
